import { useState, useEffect } from "react";
import Tooltip from "./tooltip";

const AudioComponent = ({
    url,
    displayTooltip = true,
    tooltip = null,
    icon = null,
    overColor = "#ffffff",
    bgColor = false,
    setAudioPlaying = () => {},
}) => {
    const jsAudio = new Audio("/storage/" + url);
    const [isPlaying, setIsPlaying] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipShown, setTooltipShown] = useState(false);
    const [svgBackground, setSvgBackground] = useState(bgColor || "#ffffff");

    useEffect(() => {
        return () => {
            jsAudio.pause();
            jsAudio.currentTime = 0;
            setIsPlaying(false);
        };
    }, []);

    useEffect(() => {
        jsAudio.onended = () => {
            setIsPlaying(false);
            setSvgBackground(bgColor || "#ffffff");
        };
    }, [jsAudio]);

    useEffect(() => {
        setAudioPlaying(isPlaying);
    }, [isPlaying]);

    const handleClick = () => {
        if (isPlaying) {
            jsAudio.pause();
            jsAudio.currentTime = 0;
            setIsPlaying(false);
        } else {
            jsAudio.play();
            setIsPlaying(true);
        }
        setShowTooltip(false);
        setTooltipShown(true);
    };

    return (
        <div className="fc-audio position-relative">
            <div
                className="fc-audio-inner"
                onMouseOver={() => setShowTooltip(true)}
                onMouseOut={() => setShowTooltip(false)}
                onClick={handleClick}
                onTouchStart={handleClick}
            >
                {!icon && (
                    <svg
                        width="35"
                        height="30"
                        viewBox="0 0 35 30"
                        style={{ marginLeft: "5px" }}
                        xmlns="http://www.w3.org/2000/svg"
                        onMouseOver={() =>
                            setSvgBackground(overColor || bgColor || "#ffffff")
                        }
                        onMouseOut={() =>
                            setSvgBackground(bgColor || "#ffffff")
                        }
                        fill={isPlaying ? overColor : svgBackground}
                    >
                        <path
                            d="M10.2529 0.5C10.1033 0.499976 9.95513 0.530016 9.81691 0.588404C9.67868 0.646791 9.55308 0.732381 9.44729 0.840288C9.3415 0.948194 9.25759 1.0763 9.20035 1.21729C9.1431 1.35828 9.11365 1.5094 9.11368 1.662V28.3879C9.11368 28.6961 9.2337 28.9917 9.44735 29.2096C9.66099 29.4275 9.95075 29.5499 10.2529 29.5499C10.555 29.5499 10.8448 29.4275 11.0584 29.2096C11.2721 28.9917 11.3921 28.6961 11.3921 28.3879V1.662C11.3921 1.50939 11.3627 1.35828 11.3054 1.21729C11.2482 1.0763 11.1643 0.948194 11.0585 0.840288C10.9527 0.732382 10.8271 0.64679 10.6889 0.588402C10.5507 0.530015 10.4025 0.499976 10.2529 0.5ZM5.26028 5.82836C5.39851 5.77025 5.54666 5.74035 5.69627 5.74038C5.84588 5.74035 5.99403 5.77025 6.13226 5.82836C6.27048 5.88648 6.39608 5.97167 6.50187 6.07907C6.60766 6.18647 6.69157 6.31397 6.74882 6.4543C6.80606 6.59463 6.83551 6.74504 6.83548 6.89692V23.153C6.83548 23.4597 6.71546 23.7539 6.50182 23.9708C6.28817 24.1877 5.99841 24.3095 5.69627 24.3095C5.39413 24.3095 5.10437 24.1877 4.89073 23.9708C4.67708 23.7539 4.55706 23.4597 4.55706 23.153V6.89693C4.55703 6.74504 4.58648 6.59464 4.64373 6.4543C4.70097 6.31397 4.78488 6.18647 4.89067 6.07907C4.99646 5.97167 5.12206 5.88648 5.26028 5.82836ZM0.703227 10.2711C0.841453 10.2131 0.989603 10.1832 1.13921 10.1833C1.28882 10.1832 1.43697 10.2131 1.5752 10.2711C1.71343 10.3291 1.83902 10.4141 1.94481 10.5213C2.0506 10.6285 2.13451 10.7557 2.19176 10.8958C2.249 11.0358 2.27845 11.186 2.27843 11.3375V18.7123C2.27843 18.8639 2.24896 19.014 2.19171 19.154C2.13446 19.294 2.05054 19.4213 1.94476 19.5285C1.83897 19.6357 1.71339 19.7207 1.57517 19.7787C1.43696 19.8367 1.28882 19.8666 1.13921 19.8666C0.989609 19.8666 0.841471 19.8367 0.703255 19.7787C0.56504 19.7207 0.439454 19.6357 0.333668 19.5285C0.227883 19.4213 0.143969 19.294 0.0867182 19.154C0.0294674 19.014 1.44551e-08 18.8639 1.44551e-08 18.7123V11.3375C-2.38197e-05 11.186 0.0294266 11.0358 0.086669 10.8958C0.143911 10.7557 0.227825 10.6285 0.333615 10.5213C0.439406 10.4141 0.565001 10.3291 0.703227 10.2711ZM14.374 5.82836C14.5122 5.77025 14.6603 5.74035 14.8099 5.74038C14.9596 5.74035 15.1077 5.77025 15.2459 5.82836C15.3842 5.88648 15.5098 5.97167 15.6155 6.07907C15.7213 6.18647 15.8053 6.31397 15.8625 6.4543C15.9197 6.59463 15.9492 6.74504 15.9492 6.89692V23.153C15.9492 23.4597 15.8291 23.7539 15.6155 23.9708C15.4019 24.1877 15.1121 24.3095 14.8099 24.3095C14.5078 24.3095 14.218 24.1877 14.0044 23.9708C13.7908 23.7539 13.6707 23.4597 13.6707 23.153V6.89693C13.6707 6.74504 13.7002 6.59464 13.7574 6.4543C13.8146 6.31397 13.8986 6.18647 14.0043 6.07907C14.1101 5.97167 14.2357 5.88648 14.374 5.82836ZM19.3666 10.1833C19.217 10.1832 19.0688 10.2131 18.9306 10.2711C18.7924 10.3291 18.6668 10.4141 18.561 10.5213C18.4552 10.6285 18.3713 10.7557 18.314 10.8958C18.2568 11.0358 18.2273 11.186 18.2274 11.3375V18.7123C18.2274 19.0184 18.3474 19.312 18.561 19.5285C18.7747 19.745 19.0644 19.8666 19.3666 19.8666C19.6687 19.8666 19.9585 19.745 20.1721 19.5285C20.3858 19.312 20.5058 19.0184 20.5058 18.7123V11.3375C20.5058 11.186 20.4764 11.0358 20.4191 10.8958C20.3619 10.7557 20.278 10.6285 20.1722 10.5213C20.0664 10.4141 19.9408 10.3291 19.8026 10.2711C19.6643 10.2131 19.5162 10.1832 19.3666 10.1833ZM23.4876 5.82836C23.6259 5.77025 23.774 5.74035 23.9236 5.74038C24.0732 5.74035 24.2214 5.77025 24.3596 5.82836C24.4978 5.88648 24.6234 5.97167 24.7292 6.07907C24.835 6.18647 24.9189 6.31397 24.9762 6.4543C25.0334 6.59463 25.0629 6.74504 25.0628 6.89692V23.153C25.0628 23.4597 24.9428 23.7539 24.7292 23.9708C24.5155 24.1877 24.2258 24.3095 23.9236 24.3095C23.6215 24.3095 23.3317 24.1877 23.1181 23.9708C22.9044 23.7539 22.7844 23.4597 22.7844 23.153V6.89693C22.7844 6.74504 22.8138 6.59464 22.8711 6.4543C22.9283 6.31397 23.0122 6.18647 23.118 6.07907C23.2238 5.97167 23.3494 5.88648 23.4876 5.82836ZM28.4802 10.1833C28.3306 10.1832 28.1825 10.2131 28.0443 10.2711C27.906 10.3291 27.7804 10.4141 27.6747 10.5213C27.5689 10.6285 27.4849 10.7557 27.4277 10.8958C27.3705 11.0358 27.341 11.186 27.341 11.3375V18.7123C27.341 19.0184 27.4611 19.312 27.6747 19.5285C27.8883 19.745 28.1781 19.8666 28.4802 19.8666C28.7824 19.8666 29.0721 19.745 29.2858 19.5285C29.4994 19.312 29.6195 19.0184 29.6195 18.7123V11.3375C29.6195 11.186 29.59 11.0358 29.5328 10.8958C29.4755 10.7557 29.3916 10.6285 29.2858 10.5213C29.1801 10.4141 29.0545 10.3291 28.9162 10.2711C28.778 10.2131 28.6299 10.1832 28.4802 10.1833ZM33.0373 13.8289C32.4081 13.8289 31.8981 14.3389 31.8981 14.9681C31.8981 15.5972 32.4081 16.1073 33.0373 16.1073C33.6665 16.1073 34.1765 15.5972 34.1765 14.9681C34.1765 14.3389 33.6665 13.8289 33.0373 13.8289Z"
                            fill={isPlaying ? overColor : svgBackground}
                        />
                    </svg>
                )}
                {!!icon && icon}
            </div>
            <Tooltip
                visible={showTooltip && displayTooltip && !tooltipShown}
                text={tooltip || "Escoltau"}
            />
        </div>
    );
};

export default AudioComponent;
